import React from 'react';
import { FormattedMessage } from 'react-intl';

import Advices, { AdvicesProps } from 'components/Advices';

const ProactiveWorks: React.FC<Omit<AdvicesProps, 'name'>> = (props) => (
  <>
    <div className="flex flex-col items-center gap-2">
      <FormattedMessage
        tagName="h2"
        id="proactiveWorks.title"
        defaultMessage="Proactive works"
      />
      <p className="text-center text-low">
        <FormattedMessage
          id="proactiveWorks.description"
          defaultMessage="We recommend these proactive works to save you some time."
        />
      </p>
    </div>
    <div className="w-full max-w-content">
      <ul className="content gap-5 justify-center p-0!">
        <Advices name="proactiveWorks" {...props} />
      </ul>
    </div>

  </>
);

export default ProactiveWorks;
